var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setEditLongRead } from '../../../actions/setEditLongRead';
import { MEDIA_QUERY_MOBILE } from '../../../constants/media';
import styled from 'styled-components';
import useLocalization from '../../../hooks/useLocalization';
var getVisibleColor = function (_a) {
    var colorStyle = _a.colorStyle;
    return colorStyle === 'light' ? '#909090' : '#838382';
};
var AddTextBlockRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  display: none;\n  @media (max-width: ", "px) {\n    display: block;\n    padding: 0 10px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n"], ["\n  color: ", ";\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  display: none;\n  @media (max-width: ", "px) {\n    display: block;\n    padding: 0 10px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n"])), function (props) { return getVisibleColor(props); }, MEDIA_QUERY_MOBILE);
export default function AddTextBlock(props) {
    var colorStyle = props.colorStyle, toggleMobileEditor = props.toggleMobileEditor, lgid = props.lgid;
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var handleClick = function () {
        dispatch(setEditLongRead(true, undefined, lgid));
        toggleMobileEditor && toggleMobileEditor(true);
    };
    return (React.createElement(AddTextBlockRoot, { onClick: handleClick, colorStyle: colorStyle }, t('editor.inputs.start_write')));
}
var templateObject_1;
//# sourceMappingURL=addtextblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setEditLongRead } from '../../../actions/setEditLongRead';
import { MEDIA_QUERY_MOBILE } from '../../../constants/media';
import styled from 'styled-components';
import useLocalization from '../../../hooks/useLocalization';
var getVisibleColor = function (_a) {
    var colorStyle = _a.colorStyle;
    return colorStyle === 'light' ? '#909090' : '#838382';
};
var AddTextBlockRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  display: none;\n  @media (max-width: ", "px) {\n    display: block;\n    padding: 0 10px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n"], ["\n  color: ", ";\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  display: none;\n  @media (max-width: ", "px) {\n    display: block;\n    padding: 0 10px;\n    font-size: 13px;\n    line-height: 16px;\n  }\n"])), function (props) { return getVisibleColor(props); }, MEDIA_QUERY_MOBILE);
export default function AddTextBlock(props) {
    var colorStyle = props.colorStyle, toggleMobileEditor = props.toggleMobileEditor, lgid = props.lgid;
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var handleClick = function () {
        dispatch(setEditLongRead(true, undefined, lgid));
        toggleMobileEditor && toggleMobileEditor(true);
    };
    return (React.createElement(AddTextBlockRoot, { onClick: handleClick, colorStyle: colorStyle }, t('editor.inputs.start_write')));
}
var templateObject_1;
//# sourceMappingURL=addtextblock.js.map